import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWorktangoLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 22,
	viewBox: "0 0 36 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2124_40955)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M35.7 0.311279L30.6179 21.0326H21.7812L18.5684 9.5111C18.5205 9.40139 18.4419 9.3079 18.342 9.24191C18.2422 9.17592 18.1253 9.14026 18.0056 9.13924C17.887 9.14052 17.7713 9.1758 17.6722 9.24088C17.5716 9.30676 17.492 9.40011 17.4429 9.50986L14.23 21.0313H5.39337L0.311279 0.311279H5.22479L9.28551 16.8665C9.3124 16.9573 9.35977 17.0408 9.42397 17.1105C9.48816 17.1802 9.56748 17.2342 9.65582 17.2684C9.74416 17.3027 9.83918 17.3162 9.93356 17.308C10.0279 17.2997 10.1192 17.27 10.2003 17.221C10.3081 17.1565 10.3366 17.107 10.4234 16.9371C10.6465 16.5046 12.6818 8.75622 13.0438 7.73733C13.4553 6.58084 14.0354 5.76275 14.9266 5.1529C15.8178 4.54305 16.9272 4.27531 18.0056 4.27407C19.084 4.27283 20.1959 4.54429 21.0846 5.1529C21.9734 5.76151 22.556 6.58084 22.9675 7.73733C23.3294 8.75622 25.3647 16.5046 25.5879 16.9371C25.6746 17.107 25.7031 17.1565 25.811 17.221C25.8921 17.27 25.9833 17.2997 26.0777 17.308C26.1721 17.3162 26.2671 17.3027 26.3554 17.2684C26.4438 17.2342 26.5231 17.1802 26.5873 17.1105C26.6515 17.0408 26.6989 16.9573 26.7257 16.8665L30.7865 0.311279H35.7Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2124_40955",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 36,
			height: 21.4755,
			fill: "white"
		})
	}) })]
});
export default SvgWorktangoLogo;
